import React from 'react'
import ReactDom from 'react-dom'
import { BrowserRouter } from 'react-router-dom';

import { Provider } from "react-redux";
import {store, persistor} from './redux/store';

import { PersistGate } from 'redux-persist/integration/react';


import App from './App';
import './index.css';

ReactDom.render(
  <Provider store = {store} >
    <BrowserRouter>
      <PersistGate persistor = {persistor} >
        <App/>
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'))

